import React from 'react';
import { filterDefined } from '@wix/cashier-common/dist/src/utils/filterDefined';
import { useWiredComponents } from '../../context/TopProps';
import { type WiredImageProps } from './types';

export const Image = (props: WiredImageProps) => {
  const WiredComponents = useWiredComponents();

  if (WiredComponents?.Image) {
    return <WiredComponents.Image {...props} />;
  }

  const definedProps = filterDefined({
    alt: props.alt,
    className: props.className,
    height: props.height,
    'data-hook': props['data-hook'],
  });

  const { alt, ...otherProps } = definedProps;

  return <img alt={alt} {...otherProps} src={props.src} />;
};
